export const emailTypes = {
  WORK_EMAIL: "work_email",
  PERSONAL_EMAIL: "personal_email",
};

export const phoneNumberTypes = {
  COMPANY_PHONE_NUMBER: "company_phone",
  CONTACT_PHONE_NUMBER: "contact_phone_numbers",
};

export const entityActions = {
  EDIT: "edit",
  DELETE: "delete",
  DUPLICATE: "duplicate",
};
